var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Button from "@irati/ui/src/Button";
import padding from "@irati/ui/src/global/padding";
import { ButtonLink } from "@irati/ui/src/Link";
export var ResetButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), padding.small);
var sharedStyles = "\n  margin-bottom: " + padding.small + ";\n  margin-left: " + padding.small + ";\n  min-width: 160px;\n";
export var ExportButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), sharedStyles);
export var LoadingButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), sharedStyles);
export var DownloadButton = styled(ButtonLink)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), sharedStyles);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
